import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Usuario } from '../usuario/usuario';
//import { Usuarios } from './usuarios';
import { UsuariosService } from './usuarios.service';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css'],
   providers: [
    UsuariosService
  ]
})
export class UsuariosComponent implements OnInit {

	usuarios: Usuario[];
	usuario: Usuario;

  constructor (private usuariosService: UsuariosService, private route: ActivatedRoute, private router: Router) {
	   this.usuario = new Usuario;
  }

	listarUsuarios(): void {
		this.usuariosService.getUsuarios().then((usuario) => {
					//console.log(usuario['dados']);
					this.usuarios = usuario['dados'];
				});

	}

  ngOnInit() {
	   this.listarUsuarios();
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios/usuarios.component.ts